document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('[data-product-gallery]');

  galleries.forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-main-product-image]');
    const thumbs = gallery.querySelectorAll('[data-product-thumb]');

    if (!mainImage || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const imageUrl = thumb.getAttribute('data-image-url');
        const imageAlt = thumb.getAttribute('data-image-alt') || '';

        if (imageUrl) {
          mainImage.setAttribute('src', imageUrl);
          mainImage.setAttribute('alt', imageAlt);
        }

        thumbs.forEach((button) => button.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  const aboutCarousels = document.querySelectorAll('[data-about-carousel]');

  aboutCarousels.forEach((carousel) => {
    const track = carousel.querySelector('[data-about-carousel-track]');
    const slides = carousel.querySelectorAll('[data-about-slide]');
    const prevButton = carousel.querySelector('[data-about-prev]');
    const nextButton = carousel.querySelector('[data-about-next]');

    if (!track || !slides.length) return;

    let currentIndex = 0;

    const updateCarousel = () => {
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
    };

    const showSlide = (index) => {
      currentIndex = (index + slides.length) % slides.length;
      updateCarousel();
    };

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        showSlide(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        showSlide(currentIndex + 1);
      });
    }

    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showSlide(currentIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(currentIndex + 1);
      }
    });

    updateCarousel();
  });

  const normalizeHandle = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const normalizeText = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const uniqueValues = (values) => [...new Set(values)];

  const readJsonScript = (script) => {
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  };

  const chooseVariantByFormat = (productData, grindSelection) => {
    const variants = Array.isArray(productData?.variants)
      ? productData.variants.filter((variant) => variant && variant.available !== false)
      : [];

    if (!variants.length) return null;

    if (grindSelection === 'k-cup-pods') {
      return variants[0];
    }

    const rankVariant = (variant, preferredPatterns) => {
      const title = normalizeText(variant.title);
      const isFivePound = title.includes('5lb') || title.includes('5 lb');

      if (title === 'default title') return 50;

      for (let index = 0; index < preferredPatterns.length; index += 1) {
        const pattern = preferredPatterns[index];

        if (title === pattern) {
          return index;
        }
      }

      for (let index = 0; index < preferredPatterns.length; index += 1) {
        const pattern = preferredPatterns[index];

        if (title.includes(pattern) && !isFivePound) {
          return preferredPatterns.length + index;
        }
      }

      for (let index = 0; index < preferredPatterns.length; index += 1) {
        const pattern = preferredPatterns[index];

        if (title.includes(pattern)) {
          return (preferredPatterns.length * 2) + index;
        }
      }

      return 100;
    };

    if (grindSelection === 'whole-bean') {
      const sorted = [...variants].sort((left, right) => {
        return rankVariant(left, ['whole bean']) - rankVariant(right, ['whole bean']);
      });

      return sorted[0] || variants[0];
    }

    if (grindSelection === 'ground') {
      const sorted = [...variants].sort((left, right) => {
        return rankVariant(left, ['ground coffee', 'ground']) - rankVariant(right, ['ground coffee', 'ground']);
      });

      return sorted[0] || variants[0];
    }

    return variants[0];
  };


  const escapeHtml = (value) => String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const detectSubscriptionFrequency = (plan) => {
    const source = normalizeText(`${plan?.source || ''} ${plan?.name || ''}`);

    if (
      source.includes('every other week') ||
      source.includes('biweekly') ||
      source.includes('bi weekly') ||
      source.includes('2 week') ||
      source.includes('two week')
    ) {
      return { key: '2-week', label: '2 weeks', sortOrder: 2 };
    }

    if (
      source.includes('every week') ||
      source.includes('weekly') ||
      source.includes('1 week') ||
      source.includes('one week')
    ) {
      return { key: '1-week', label: '1 week', sortOrder: 1 };
    }

    if (
      source.includes('3 week') ||
      source.includes('three week')
    ) {
      return { key: '3-week', label: '3 weeks', sortOrder: 3 };
    }

    if (
      source.includes('4 week') ||
      source.includes('four week')
    ) {
      return { key: '4-week', label: '4 weeks', sortOrder: 4 };
    }

    return {
      key: `plan-${plan?.id || 'custom'}`,
      label: plan?.name || 'Subscription',
      sortOrder: 90
    };
  };

  const productSubscriptionWidgets = document.querySelectorAll('[data-product-subscription]');

  productSubscriptionWidgets.forEach((widget) => {
    const form = widget.closest('form');
    if (!form) return;

    const purchaseOptions = widget.querySelector('[data-purchase-options]');
    const frequencyShell = widget.querySelector('[data-subscription-frequency-shell]');
    const frequencyList = widget.querySelector('[data-subscription-frequency-list]');
    const note = widget.querySelector('[data-subscription-note]');
    const sellingPlanInput = widget.querySelector('[data-selling-plan-input]');
    const variantField = form.querySelector('select[name="id"], input[name="id"]');
    const noPlanMessage = widget.getAttribute('data-no-plan-message') || 'Subscriptions are not available for this option right now.';
    const oneTimeLabel = widget.getAttribute('data-one-time-label') || 'One-time purchase';
    const subscribeLabel = widget.getAttribute('data-subscribe-label') || 'Subscribe';
    const variantDataMap = {};
    const scripts = Array.from(widget.querySelectorAll('[data-variant-selling-plans]'));

    scripts.forEach((script) => {
      const data = readJsonScript(script);

      if (data && data.variantId != null) {
        variantDataMap[String(data.variantId)] = data;
      }
    });

    const getCurrentVariantId = () => {
      if (variantField) {
        return String(variantField.value || widget.getAttribute('data-current-variant-id') || '');
      }

      return String(widget.getAttribute('data-current-variant-id') || '');
    };

    const getCurrentVariantData = () => {
      const currentVariantId = getCurrentVariantId();

      if (currentVariantId && variantDataMap[currentVariantId]) {
        return variantDataMap[currentVariantId];
      }

      return Object.values(variantDataMap)[0] || null;
    };

    const normalizePlans = (plans) => {
      const seenKeys = new Set();

      return (Array.isArray(plans) ? plans : [])
        .map((plan) => {
          const frequency = detectSubscriptionFrequency(plan);

          return {
            ...plan,
            frequencyKey: frequency.key,
            displayLabel: frequency.label,
            sortOrder: frequency.sortOrder
          };
        })
        .sort((left, right) => {
          return left.sortOrder - right.sortOrder || Number(left.id) - Number(right.id);
        })
        .filter((plan) => {
          if (seenKeys.has(plan.frequencyKey)) {
            return false;
          }

          seenKeys.add(plan.frequencyKey);
          return true;
        });
    };

    if (!Object.values(variantDataMap).some((variantData) => Array.isArray(variantData?.plans) && variantData.plans.length)) {
      widget.hidden = true;
      return;
    }

    let purchaseMode = widget.getAttribute('data-requires-selling-plan') === 'true' ? 'subscription' : 'one_time';
    let selectedPlanId = '';
    let selectedFrequencyKey = '';

    const buildPriceMarkup = (price, compareAtPrice, hasDiscount) => {
      const parts = ['<span class="product-subscription__price">', escapeHtml(price || ''), '</span>'];

      if (hasDiscount && compareAtPrice) {
        return [
          '<span class="product-subscription__price-row">',
          '<span class="product-subscription__compare-price">', escapeHtml(compareAtPrice), '</span>',
          parts.join(''),
          '</span>'
        ].join('');
      }

      return parts.join('');
    };

    const renderChoices = (variantData, plans, activePlan) => {
      if (!purchaseOptions) return;

      const choiceMarkup = [];
      const hasSubscriptionPlans = plans.length > 0;
      const requiresSellingPlan = Boolean(variantData?.requiresSellingPlan);

      if (!requiresSellingPlan) {
        choiceMarkup.push([
          '<button type="button" class="product-subscription__choice',
          purchaseMode === 'one_time' ? ' is-selected' : '',
          '" data-subscription-mode="one_time" aria-pressed="',
          purchaseMode === 'one_time' ? 'true' : 'false',
          '">',
          '<span class="product-subscription__choice-label">', escapeHtml(oneTimeLabel), '</span>',
          buildPriceMarkup(variantData?.oneTimePrice || '', variantData?.oneTimeCompareAtPrice || '', Boolean(variantData?.oneTimeHasDiscount)),
          '</button>'
        ].join(''));
      }

      choiceMarkup.push([
        '<button type="button" class="product-subscription__choice',
        purchaseMode === 'subscription' ? ' is-selected' : '',
        '" data-subscription-mode="subscription" aria-pressed="',
        purchaseMode === 'subscription' ? 'true' : 'false',
        '"',
        hasSubscriptionPlans ? '' : ' disabled',
        '>',
        '<span class="product-subscription__choice-label">', escapeHtml(subscribeLabel), '</span>',
        '<span class="product-subscription__choice-meta">',
        activePlan
          ? `${escapeHtml(activePlan.displayLabel)} · ${buildPriceMarkup(activePlan.price || '', activePlan.compareAtPrice || '', Boolean(activePlan.hasDiscount))}`
          : escapeHtml(hasSubscriptionPlans ? 'Choose frequency below' : noPlanMessage),
        '</span>',
        '</button>'
      ].join(''));

      purchaseOptions.innerHTML = choiceMarkup.join('');

      Array.from(purchaseOptions.querySelectorAll('[data-subscription-mode]')).forEach((button) => {
        button.addEventListener('click', () => {
          const nextMode = button.getAttribute('data-subscription-mode');

          if (nextMode === 'subscription' && !plans.length) {
            return;
          }

          purchaseMode = nextMode || 'one_time';

          if (purchaseMode === 'subscription' && !selectedPlanId && plans[0]) {
            selectedPlanId = String(plans[0].id);
            selectedFrequencyKey = plans[0].frequencyKey;
          }

          render();
        });
      });
    };

    const renderFrequencies = (plans, activePlan) => {
      if (!frequencyShell || !frequencyList) return;

      if (purchaseMode !== 'subscription' || !plans.length) {
        frequencyShell.hidden = true;
        frequencyList.innerHTML = '';
        return;
      }

      frequencyShell.hidden = false;
      frequencyList.innerHTML = plans.map((plan) => {
        return [
          '<button type="button" class="product-subscription__frequency',
          activePlan && String(activePlan.id) === String(plan.id) ? ' is-selected' : '',
          '" data-selling-plan-id="', escapeHtml(plan.id), '" data-frequency-key="', escapeHtml(plan.frequencyKey), '">',
          '<span class="product-subscription__frequency-label">', escapeHtml(plan.displayLabel), '</span>',
          buildPriceMarkup(plan.price || '', plan.compareAtPrice || '', Boolean(plan.hasDiscount)),
          '</button>'
        ].join('');
      }).join('');

      Array.from(frequencyList.querySelectorAll('[data-selling-plan-id]')).forEach((button) => {
        button.addEventListener('click', () => {
          selectedPlanId = button.getAttribute('data-selling-plan-id') || '';
          selectedFrequencyKey = button.getAttribute('data-frequency-key') || '';
          purchaseMode = 'subscription';
          render();
        });
      });
    };

    const renderNote = (variantData, plans, activePlan) => {
      if (!note) return;

      if (!plans.length && !variantData?.requiresSellingPlan) {
        note.hidden = false;
        note.textContent = noPlanMessage;
        return;
      }

      if (purchaseMode === 'subscription' && activePlan) {
        note.hidden = false;
        note.textContent = `Subscription selected: ${activePlan.displayLabel} · ${activePlan.price} per order`;
        return;
      }

      note.hidden = true;
      note.textContent = '';
    };

    const syncSellingPlanInput = (variantData, activePlan) => {
      if (!sellingPlanInput) return;

      if (variantData?.requiresSellingPlan) {
        sellingPlanInput.value = activePlan ? activePlan.id : '';
        return;
      }

      if (purchaseMode === 'subscription' && activePlan) {
        sellingPlanInput.value = activePlan.id;
        return;
      }

      sellingPlanInput.value = '';
    };

    const getActivePlan = (variantData, plans) => {
      if (variantData?.requiresSellingPlan) {
        purchaseMode = 'subscription';
      }

      if (purchaseMode !== 'subscription') {
        selectedPlanId = '';
        return null;
      }

      if (!plans.length) {
        if (!variantData?.requiresSellingPlan) {
          purchaseMode = 'one_time';
        }

        selectedPlanId = '';
        selectedFrequencyKey = '';
        return null;
      }

      let activePlan = plans.find((plan) => String(plan.id) === String(selectedPlanId));

      if (!activePlan && selectedFrequencyKey) {
        activePlan = plans.find((plan) => plan.frequencyKey === selectedFrequencyKey);
      }

      if (!activePlan) {
        activePlan = plans[0];
      }

      if (activePlan) {
        selectedPlanId = String(activePlan.id);
        selectedFrequencyKey = activePlan.frequencyKey;
      }

      return activePlan || null;
    };

    const render = () => {
      const variantData = getCurrentVariantData();

      if (!variantData) {
        widget.hidden = true;
        return;
      }

      widget.hidden = false;

      const plans = normalizePlans(variantData.plans);
      const activePlan = getActivePlan(variantData, plans);

      renderChoices(variantData, plans, activePlan);
      renderFrequencies(plans, activePlan);
      renderNote(variantData, plans, activePlan);
      syncSellingPlanInput(variantData, activePlan);
    };

    if (variantField && variantField.tagName === 'SELECT') {
      variantField.addEventListener('change', () => {
        render();
      });
    }

    form.addEventListener('submit', () => {
      const sellingPlanInputs = form.querySelectorAll('input[name="selling_plan"]');

      sellingPlanInputs.forEach((input) => {
        if (input !== sellingPlanInput) {
          input.disabled = true;
        }
      });
    });

    render();
  });

  
  const bundleRules = {
    roast: {
      'dark-roast': ['deep-rough', 'fairway-fuel'],
      'medium-roast': ['first-cut', 'fairway-reserve', 'mulligan'],
      'light-roast': ['second-cut', 'bunker-blend', 'fairway-reserve']
    },
    origin: {
      'single-origin': ['second-cut', 'fairway-fuel', 'fairway-reserve'],
      blend: ['bunker-blend', 'first-cut', 'deep-rough', 'mulligan']
    },
    pods: ['first-cut', 'deep-rough'],
    bestsellers: ['fairway-reserve', 'first-cut', 'bunker-blend']
  };

  const bundleWidgetSections = Array.from(document.querySelectorAll('[data-bundle-widget-section]'));

  const updateBundleWidgetSections = (detail) => {
    bundleWidgetSections.forEach((widgetSection) => {
      const widgetSlot = widgetSection.querySelector('[data-bundle-app-slot]');
      const widgetHint = widgetSection.querySelector('[data-bundle-widget-hint]');
      const placeholderMessage = widgetHint ? (widgetHint.getAttribute('data-placeholder-message') || '') : '';
      const readyMessage = widgetHint ? (widgetHint.getAttribute('data-ready-message') || '') : '';

      const recommendedKeys = (detail && Array.isArray(detail.recommendedKeys)) ? detail.recommendedKeys : [];
      const recommendedLabels = (detail && Array.isArray(detail.recommendedLabels)) ? detail.recommendedLabels : [];
      const recommendedProducts = (detail && Array.isArray(detail.recommendedProducts)) ? detail.recommendedProducts : [];
      const selections = (detail && detail.selections) ? detail.selections : {};
      const complete = Boolean(detail && detail.complete);

      const answeredValues = {};

      Object.keys(selections).forEach((key) => {
        answeredValues[key] = selections[key] ? selections[key].value || '' : '';
      });

      widgetSection.dataset.bundleRecommendedKeys = recommendedKeys.join(',');
      widgetSection.dataset.bundleRecommendedLabels = recommendedLabels.join('|');
      widgetSection.dataset.bundleRecommendedHandles = recommendedProducts.map((entry) => entry.handle).filter(Boolean).join(',');
      widgetSection.dataset.bundleSelections = JSON.stringify(answeredValues);
      widgetSection.dataset.bundleRecommendedProducts = JSON.stringify(recommendedProducts);

      if (widgetSlot) {
        widgetSlot.dataset.bundleRecommendedKeys = widgetSection.dataset.bundleRecommendedKeys || '';
        widgetSlot.dataset.bundleRecommendedLabels = widgetSection.dataset.bundleRecommendedLabels || '';
        widgetSlot.dataset.bundleRecommendedHandles = widgetSection.dataset.bundleRecommendedHandles || '';
        widgetSlot.dataset.bundleSelections = widgetSection.dataset.bundleSelections || '';
        widgetSlot.dataset.bundleRecommendedProducts = widgetSection.dataset.bundleRecommendedProducts || '';
      }

      if (widgetHint) {
        widgetHint.textContent = complete && recommendedLabels.length ? readyMessage : placeholderMessage;
      }
    });
  };

  updateBundleWidgetSections({
    recommendedKeys: [],
    recommendedLabels: [],
    recommendedProducts: [],
    selections: {},
    complete: false
  });

  const bundleQuizSections = document.querySelectorAll('[data-bundle-quiz]');

  bundleQuizSections.forEach((quizSection) => {
    if (quizSection.dataset.bundleQuizInitialized === 'true') return;
    quizSection.dataset.bundleQuizInitialized = 'true';

    const builder = quizSection.querySelector('[data-bundle-builder]');
    if (!builder) return;

    const questions = Array.from(builder.querySelectorAll('[data-bundle-question]'));
    if (!questions.length) return;

    const resetButton = builder.querySelector('[data-bundle-reset]');
    const backButton = builder.querySelector('[data-bundle-back]');
    const status = builder.querySelector('[data-bundle-status]');
    const currentStepText = builder.querySelector('[data-bundle-current-step]');
    const progressDots = Array.from(builder.querySelectorAll('[data-bundle-progress-dot]'));
    const recommendationBox = builder.querySelector('[data-bundle-recommendation-box]');
    const recommendationSummary = builder.querySelector('[data-bundle-recommendation-summary]');
    const recommendationChips = builder.querySelector('[data-bundle-recommendation-chips]');
    const itemMaps = Array.from(quizSection.querySelectorAll('[data-bundle-item-map]'))
      .map((script) => readJsonScript(script))
      .filter(Boolean);

    const isCoffeeFinderPopupQuiz = (quizSection.getAttribute('data-section-id') || '') === 'coffee-finder-popup';
    const popupRootForQuiz = isCoffeeFinderPopupQuiz ? quizSection.closest('[data-coffee-finder-popup]') : null;
    const popupDialogForQuiz = popupRootForQuiz ? popupRootForQuiz.querySelector('.coffee-finder-popup__dialog') : null;
    const popupSelectionsStorageKey = 'birdieCoffeeFinderPopupSelections';

    const readPopupStoredSelections = () => {
      if (!isCoffeeFinderPopupQuiz || !window.sessionStorage) return {};

      try {
        return JSON.parse(window.sessionStorage.getItem(popupSelectionsStorageKey) || '{}') || {};
      } catch (error) {
        return {};
      }
    };

    const scrollQuizElementIntoView = (element) => {
      if (!element) return;

      if (popupDialogForQuiz && popupDialogForQuiz.contains(element)) {
        const dialogRect = popupDialogForQuiz.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        const nextTop = popupDialogForQuiz.scrollTop + elementRect.top - dialogRect.top - 28;

        popupDialogForQuiz.scrollTo({
          top: Math.max(0, nextTop),
          behavior: 'smooth'
        });

        return;
      }

      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    const focusQuizElement = (element) => {
      if (!element || typeof element.focus !== 'function') return;

      window.requestAnimationFrame(() => {
        try {
          element.focus({ preventScroll: true });
        } catch (error) {
          element.focus();
        }
      });
    };

    const incompleteMessage = builder.getAttribute('data-incomplete-message') || 'Choose an option to keep building your Birdie match.';
    const completeMessage = builder.getAttribute('data-complete-message') || 'Your Birdie starting lineup is ready.';
    const recommendationBody = builder.getAttribute('data-recommendation-body') || 'These coffees are the closest fit based on your answers. Use the bundle below to choose whatever you want.';
    const recommendationPlaceholder = builder.getAttribute('data-recommendation-placeholder') || 'Finish the steps above to see your recommended starting coffees.';

    let currentStepIndex = 0;

    const getSelections = () => {
      const selectionState = {};

      questions.forEach((question) => {
        const questionKey = normalizeHandle(question.getAttribute('data-question-key'));
        const selectedOption = question.querySelector('[data-bundle-option].is-selected');

        selectionState[questionKey] = {
          value: selectedOption ? normalizeHandle(selectedOption.getAttribute('data-option-value') || selectedOption.textContent) : '',
          label: selectedOption ? (selectedOption.getAttribute('data-option-label') || selectedOption.textContent.trim()) : ''
        };
      });

      return selectionState;
    };

    const getAnsweredCount = (selections) => {
      return Object.values(selections).filter((selection) => selection.value).length;
    };

    const getRecommendedKeys = (selections) => {
      const roastValue = selections['roasting-profile'] ? selections['roasting-profile'].value : '';
      const originValue = selections['origin'] ? selections['origin'].value : '';
      const grindValue = selections['grind-size'] ? selections['grind-size'].value : '';
      const anyDontKnow = Object.values(selections).some((selection) => selection.value === 'i-dont-know');

      if (anyDontKnow) {
        if (grindValue === 'k-cup-pods') {
          return [...bundleRules.pods].slice(0, 3);
        }

        return [...bundleRules.bestsellers].slice(0, 3);
      }

      if (grindValue === 'k-cup-pods') {
        return [...bundleRules.pods].slice(0, 3);
      }

      const answeredSets = [];

      if (roastValue && bundleRules.roast[roastValue]) {
        answeredSets.push([...bundleRules.roast[roastValue]]);
      }

      if (originValue && bundleRules.origin[originValue]) {
        answeredSets.push([...bundleRules.origin[originValue]]);
      }

      if (!answeredSets.length) {
        return [];
      }

      if (answeredSets.length === 1) {
        return uniqueValues(answeredSets[0]).slice(0, 3);
      }

      const intersection = answeredSets.reduce((current, next) => current.filter((itemKey) => next.includes(itemKey)));

      if (intersection.length) {
        return uniqueValues(intersection).slice(0, 3);
      }

      return uniqueValues(answeredSets.flat()).slice(0, 3);
    };

    const getRecommendedEntries = (recommendedKeys, selections) => {
      const grindValue = selections['grind-size'] ? selections['grind-size'].value : '';
      const shouldUsePods = grindValue === 'k-cup-pods';

      return recommendedKeys.map((itemKey) => {
        const item = itemMaps.find((entry) => normalizeHandle(entry.key) === itemKey);
        if (!item) {
          return {
            key: itemKey,
            label: itemKey,
            handle: '',
            url: '',
            variantId: '',
            price: '',
            image: ''
          };
        }

        const handle = shouldUsePods
          ? item.pods_handle || item.regular_handle || ''
          : item.regular_handle || item.pods_handle || '';

        const url = shouldUsePods
          ? item.pods_url || item.regular_url || ''
          : item.regular_url || item.pods_url || '';

        const variants = shouldUsePods
          ? item.pods_variants || item.regular_variants || []
          : item.regular_variants || item.pods_variants || [];
        const selectedVariant = chooseVariantByFormat({ variants }, grindValue);

        const fallbackVariantId = shouldUsePods
          ? item.pods_variant_id || item.regular_variant_id || ''
          : item.regular_variant_id || item.pods_variant_id || '';

        const fallbackPrice = shouldUsePods
          ? item.pods_price || item.regular_price || ''
          : item.regular_price || item.pods_price || '';

        const image = shouldUsePods
          ? item.pods_image || item.regular_image || ''
          : item.regular_image || item.pods_image || '';

        return {
          key: itemKey,
          label: item.label || itemKey,
          handle,
          url,
          variantId: selectedVariant && selectedVariant.id ? selectedVariant.id : fallbackVariantId,
          variantTitle: selectedVariant && selectedVariant.title ? selectedVariant.title : '',
          price: selectedVariant && selectedVariant.price ? selectedVariant.price : fallbackPrice,
          image
        };
      }).filter(Boolean).slice(0, 3);
    };

    const getRecommendedLabels = (recommendedKeys) => {
      return recommendedKeys.map((itemKey) => {
        const item = itemMaps.find((entry) => normalizeHandle(entry.key) === itemKey);
        return item ? item.label || itemKey : itemKey;
      }).slice(0, 3);
    };

    const getFirstUnansweredIndex = (selections) => {
      return questions.findIndex((question) => {
        const questionKey = normalizeHandle(question.getAttribute('data-question-key'));
        return !(selections[questionKey] && selections[questionKey].value);
      });
    };

    const updateStepUI = (selections) => {
      const answeredCount = getAnsweredCount(selections);
      const firstUnansweredIndex = getFirstUnansweredIndex(selections);

      if (firstUnansweredIndex >= 0 && currentStepIndex > firstUnansweredIndex) {
        currentStepIndex = firstUnansweredIndex;
      }

      if (currentStepIndex < 0) {
        currentStepIndex = 0;
      }

      if (currentStepIndex > questions.length - 1) {
        currentStepIndex = questions.length - 1;
      }

      questions.forEach((question, index) => {
        const questionKey = normalizeHandle(question.getAttribute('data-question-key'));
        const hasAnswer = selections[questionKey] && selections[questionKey].value;
        const isActive = index === currentStepIndex;

        question.hidden = !isActive;
        question.classList.toggle('is-active', isActive);
        question.classList.toggle('is-complete', Boolean(hasAnswer));
      });

      progressDots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentStepIndex);
        dot.classList.toggle('is-complete', index < answeredCount);
      });

      if (currentStepText) {
        if (answeredCount === questions.length && currentStepIndex === questions.length - 1) {
          currentStepText.textContent = `All ${questions.length} steps complete`;
        } else {
          currentStepText.textContent = `Step ${currentStepIndex + 1} of ${questions.length}`;
        }
      }

      if (backButton) {
        backButton.hidden = currentStepIndex === 0;
      }
    };

    const getStatusMessage = (selections, recommendedKeys) => {
      const answeredCount = getAnsweredCount(selections);
      const grindValue = selections['grind-size'] ? selections['grind-size'].value : '';
      const anyDontKnow = Object.values(selections).some((selection) => selection.value === 'i-dont-know');

      if (!recommendedKeys.length) {
        return incompleteMessage;
      }

      if (anyDontKnow && grindValue === 'k-cup-pods') {
        return 'We are steering you toward the pod-ready lineup.';
      }

      if (anyDontKnow) {
        return 'We are steering you toward Birdie favorites.';
      }

      if (answeredCount === questions.length) {
        return completeMessage;
      }

      return 'Nice — keep going and we will keep refining your lineup.';
    };

    const normalizeRecommendationProductUrl = (url, handle) => {
      const rawUrl = String(url || '').trim();

      if (rawUrl.includes('/collections/') && rawUrl.includes('/products/')) {
        const productPath = rawUrl.split('/products/').pop();
        return productPath ? `/products/${productPath}` : rawUrl;
      }

      if (rawUrl) {
        return rawUrl;
      }

      const cleanHandle = String(handle || '').trim();
      return cleanHandle ? `/products/${encodeURIComponent(cleanHandle)}` : '';
    };

    const buildRecommendationCard = (product, selections) => {
      const productUrl = product ? normalizeRecommendationProductUrl(product.url, product.handle) : '';
      const card = document.createElement('article');
      card.className = 'bundle-recommendation-card';

      if (!product || !product.image) {
        card.classList.add('bundle-recommendation-card--no-image');
      }

      if (product && product.image) {
        const imageLink = document.createElement(productUrl ? 'a' : 'span');
        imageLink.className = 'bundle-recommendation-card__image-link';

        if (productUrl) {
          imageLink.setAttribute('href', productUrl);
          imageLink.setAttribute('aria-label', `View ${product.label}`);
        }

        const image = document.createElement('img');
        image.className = 'bundle-recommendation-card__image';
        image.src = product.image;
        image.alt = product.label || 'Recommended Birdie coffee';
        image.loading = 'lazy';
        image.width = 180;
        image.height = 180;
        imageLink.appendChild(image);
        card.appendChild(imageLink);
      }

      const body = document.createElement('div');
      body.className = 'bundle-recommendation-card__body';

      const title = document.createElement(productUrl ? 'a' : 'span');
      title.className = 'bundle-recommendation-card__title';

      if (productUrl) {
        title.setAttribute('href', productUrl);
      }

      title.textContent = product && product.label ? product.label : 'Recommended coffee';
      body.appendChild(title);

      if (product && product.variantTitle && normalizeHandle(product.variantTitle) !== 'default-title') {
        const variant = document.createElement('p');
        variant.className = 'bundle-recommendation-card__variant';
        variant.textContent = product.variantTitle;
        body.appendChild(variant);
      }

      if (product && product.price) {
        const price = document.createElement('p');
        price.className = 'bundle-recommendation-card__price';
        price.textContent = product.price;
        body.appendChild(price);
      }

      const actions = document.createElement('div');
      actions.className = 'bundle-recommendation-card__actions';

      if (product && (product.variantId || product.handle || productUrl)) {
        const addButton = document.createElement('button');
        const grindSelection = selections && selections['grind-size'] ? selections['grind-size'].value : '';

        addButton.className = 'button bundle-recommendation-card__add';
        addButton.type = 'button';
        addButton.dataset.bundleRecommendationAdd = 'true';
        addButton.dataset.variantId = product.variantId ? String(product.variantId) : '';
        addButton.dataset.productHandle = product.handle ? String(product.handle) : '';
        addButton.dataset.productUrl = productUrl ? String(productUrl) : '';
        addButton.dataset.grindSelection = grindSelection;
        addButton.dataset.productTitle = product.label || 'This coffee';
        addButton.textContent = 'Add to cart';
        actions.appendChild(addButton);
      }

      if (productUrl) {
        const viewLink = document.createElement('a');
        viewLink.className = 'button-secondary bundle-recommendation-card__view';
        viewLink.href = productUrl;
        viewLink.textContent = 'View product';
        actions.appendChild(viewLink);
      }

      body.appendChild(actions);
      card.appendChild(body);
      return card;
    };

    const updateRecommendationBox = (selections, recommendedKeys) => {
      const recommendedLabels = getRecommendedLabels(recommendedKeys);
      const recommendedProducts = getRecommendedEntries(recommendedKeys, selections);
      const complete = getAnsweredCount(selections) === questions.length;

      if (recommendationSummary && !complete) {
        recommendationSummary.textContent = recommendationPlaceholder;
      }

      if (recommendationChips) {
        recommendationChips.innerHTML = '';
        recommendationChips.classList.remove('has-recommendation-cards');
      }

      if (recommendationBox) {
        recommendationBox.hidden = !(complete && recommendedProducts.length);
      }

      if (complete && recommendedProducts.length && recommendationChips) {
        if (recommendationSummary) {
          recommendationSummary.textContent = recommendationBody;
        }

        recommendationChips.classList.add('has-recommendation-cards');

        recommendedProducts.forEach((product) => {
          const productUrl = product ? normalizeRecommendationProductUrl(product.url, product.handle) : '';
          const hasCardActions = Boolean(product && (product.variantId || productUrl || product.image || product.price));

          if (hasCardActions) {
            recommendationChips.appendChild(buildRecommendationCard(product, selections));
            return;
          }

          const chipTag = productUrl ? 'a' : 'span';
          const chip = document.createElement(chipTag);
          chip.className = 'bundle-recommendation-box__chip';

          if (productUrl) {
            chip.classList.add('bundle-recommendation-box__chip--link');
            chip.setAttribute('href', productUrl);
            chip.setAttribute('aria-label', `View ${product.label}`);
          }

          chip.textContent = product && product.label ? product.label : '';
          recommendationChips.appendChild(chip);
        });
      }

      const detail = {
        sectionId: quizSection.getAttribute('data-section-id') || '',
        selections,
        recommendedKeys,
        recommendedLabels,
        recommendedProducts,
        complete
      };

      window.BirdieBundleRecommendations = window.BirdieBundleRecommendations || {};
      const sectionId = quizSection.getAttribute('data-section-id') || 'default';
      window.BirdieBundleRecommendations[sectionId] = detail;
      window.BirdieBundleRecommendations.current = detail;

      updateBundleWidgetSections(detail);

      document.dispatchEvent(new CustomEvent('birdie:bundle-recommendations-update', { detail }));
      quizSection.dispatchEvent(new CustomEvent('birdie:bundle-recommendations-update', { bubbles: true, detail }));
    };

    const syncBuilder = () => {
      const selections = getSelections();
      const recommendedKeys = getRecommendedKeys(selections);

      updateStepUI(selections);

      if (status) {
        status.textContent = getStatusMessage(selections, recommendedKeys);
      }

      updateRecommendationBox(selections, recommendedKeys);
    };

    questions.forEach((question, index) => {
      const options = Array.from(question.querySelectorAll('[data-bundle-option]'));
      const input = question.querySelector('[data-bundle-input]');

      options.forEach((option) => {
        option.addEventListener('click', () => {
          options.forEach((button) => button.classList.remove('is-selected'));
          option.classList.add('is-selected');

          if (input) {
            input.value = option.getAttribute('data-option-value') || option.textContent.trim();
          }

          if (index < questions.length - 1) {
            currentStepIndex = index + 1;
          } else {
            currentStepIndex = index;
          }

          syncBuilder();

          if (index < questions.length - 1 && questions[currentStepIndex]) {
            window.requestAnimationFrame(() => {
              scrollQuizElementIntoView(questions[currentStepIndex]);
              focusQuizElement(questions[currentStepIndex].querySelector('[data-bundle-option]'));
            });
          } else if (recommendationBox && !recommendationBox.hidden) {
            window.requestAnimationFrame(() => {
              scrollQuizElementIntoView(recommendationBox);
              focusQuizElement(recommendationBox.querySelector('a, button'));
            });
          }
        });
      });
    });

    if (backButton) {
      backButton.addEventListener('click', () => {
        currentStepIndex = Math.max(0, currentStepIndex - 1);
        syncBuilder();

        if (questions[currentStepIndex]) {
          scrollQuizElementIntoView(questions[currentStepIndex]);
          focusQuizElement(questions[currentStepIndex].querySelector('[data-bundle-option]'));
        }
      });
    }

    if (resetButton) {
      resetButton.addEventListener('click', () => {
        questions.forEach((question) => {
          const options = question.querySelectorAll('[data-bundle-option]');
          const input = question.querySelector('[data-bundle-input]');

          options.forEach((option) => option.classList.remove('is-selected'));

          if (input) {
            input.value = '';
          }
        });

        currentStepIndex = 0;
        syncBuilder();

        if (questions[0]) {
          scrollQuizElementIntoView(questions[0]);
          focusQuizElement(questions[0].querySelector('[data-bundle-option]'));
        }
      });
    }

    const getRecommendationProductJsonUrl = (url, handle) => {
      const normalizedUrl = normalizeRecommendationProductUrl(url, handle);
      const cleanUrl = String(normalizedUrl || '').split('?')[0].replace(/\/$/, '');

      if (cleanUrl) {
        return cleanUrl.endsWith('.js') ? cleanUrl : `${cleanUrl}.js`;
      }

      return '';
    };

    const resolveRecommendationVariantId = (addButton) => {
      const existingVariantId = addButton.getAttribute('data-variant-id');
      if (existingVariantId) return Promise.resolve(existingVariantId);

      const productUrl = addButton.getAttribute('data-product-url') || '';
      const productHandle = addButton.getAttribute('data-product-handle') || '';
      const grindSelection = addButton.getAttribute('data-grind-selection') || '';
      const productJsonUrl = getRecommendationProductJsonUrl(productUrl, productHandle);

      if (!window.fetch || !productJsonUrl) {
        return Promise.reject(new Error('Open the product to choose a format and add it to your cart.'));
      }

      return fetch(productJsonUrl, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Open the product to choose a format and add it to your cart.');
          }

          return response.json();
        })
        .then((productData) => {
          const variant = chooseVariantByFormat(productData, grindSelection);

          if (!variant || !variant.id) {
            throw new Error('This recommendation is not available to add right now.');
          }

          return variant.id;
        });
    };

    if (recommendationBox) {
      recommendationBox.addEventListener('click', (event) => {
        const addButton = event.target.closest('[data-bundle-recommendation-add]');
        if (!addButton || !window.fetch) return;

        event.preventDefault();

        const defaultLabel = addButton.textContent || 'Add to cart';
        const productTitle = addButton.getAttribute('data-product-title') || 'This coffee';
        const statusTarget = recommendationBox.querySelector('[data-bundle-recommendation-cart-status]');

        addButton.disabled = true;
        addButton.setAttribute('aria-busy', 'true');
        addButton.textContent = 'Adding...';

        if (statusTarget) {
          statusTarget.classList.remove('visually-hidden');
          statusTarget.textContent = `Adding ${productTitle} to your cart.`;
        }

        resolveRecommendationVariantId(addButton)
          .then((variantId) => fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          }))
          .then((response) => {
            if (!response.ok) {
              return response.json().then((error) => Promise.reject(error));
            }

            return response.json();
          })
          .then(() => fetch('/cart.js', {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          }))
          .then((response) => response && response.ok ? response.json() : null)
          .then((cart) => {
            if (cart && typeof cart.item_count !== 'undefined') {
              document.querySelectorAll('[data-cart-count]').forEach((counter) => {
                counter.textContent = String(cart.item_count || 0);
                counter.classList.toggle('is-empty', !cart.item_count);
              });

              document.querySelectorAll('[data-header-cart-link]').forEach((link) => {
                link.setAttribute('aria-label', `Cart, ${cart.item_count || 0} item${cart.item_count === 1 ? '' : 's'}`);
              });
            }

            addButton.textContent = 'Added';

            if (statusTarget) {
              statusTarget.textContent = `${productTitle} was added to your cart.`;
            }

            document.dispatchEvent(new CustomEvent('birdie:cart-updated', { detail: cart || {} }));
          })
          .catch((error) => {
            const errorMessage = error && (error.description || error.message)
              ? (error.description || error.message)
              : 'We could not add this item. Please use View product to choose a format.';

            addButton.textContent = 'Try again';

            if (statusTarget) {
              statusTarget.classList.remove('visually-hidden');
              statusTarget.textContent = errorMessage;
            }
          })
          .finally(() => {
            window.setTimeout(() => {
              addButton.disabled = false;
              addButton.removeAttribute('aria-busy');
              addButton.textContent = defaultLabel;
            }, 1800);
          });
      });
    }

    if (isCoffeeFinderPopupQuiz) {
      const storedSelections = readPopupStoredSelections();
      let restoredAnswerCount = 0;

      questions.forEach((question) => {
        const questionKey = normalizeHandle(question.getAttribute('data-question-key'));
        const storedValue = storedSelections[questionKey] || '';
        if (!storedValue) return;

        const options = Array.from(question.querySelectorAll('[data-bundle-option]'));
        const input = question.querySelector('[data-bundle-input]');
        const storedOption = options.find((option) => normalizeHandle(option.getAttribute('data-option-value') || option.textContent) === normalizeHandle(storedValue));
        if (!storedOption) return;

        options.forEach((option) => option.classList.remove('is-selected'));
        storedOption.classList.add('is-selected');

        if (input) {
          input.value = storedOption.getAttribute('data-option-value') || storedOption.textContent.trim();
        }

        restoredAnswerCount += 1;
      });

      if (restoredAnswerCount) {
        const restoredSelections = getSelections();
        const firstUnansweredIndex = getFirstUnansweredIndex(restoredSelections);
        currentStepIndex = firstUnansweredIndex >= 0 ? firstUnansweredIndex : questions.length - 1;
      }
    }

    syncBuilder();
  });


  const removeBirdieContactPhoneNumber = () => {
    const path = window.location.pathname.toLowerCase();
    const pageTitle = document.title.toLowerCase();
    const bodyClass = (document.body && document.body.className ? document.body.className : '').toLowerCase();
    const isContactArea = path.includes('/pages/contact') ||
      path.includes('/policies/contact-information') ||
      bodyClass.includes('page-handle-contact') ||
      pageTitle.includes('contact information') ||
      pageTitle.includes('contact us');

    if (!isContactArea) return;

    const contactRoot = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    if (!contactRoot) return;

    const phoneSource = String.raw`(?:\(?\+?1\)?[\s.\-\u00a0]*)?\(?904\)?[\s.\-\u00a0]*200[\s.\-\u00a0]*5884`;
    const phonePattern = new RegExp(phoneSource, 'i');
    const phonePatternGlobal = new RegExp(phoneSource, 'gi');
    const phoneLinePattern = new RegExp(String.raw`^\s*(?:phone|telephone|tel|mobile|contact\s+business)?\s*:?\s*${phoneSource}\s*$`, 'i');
    const phoneLabelOnlyPattern = /^\s*(?:phone|telephone|tel|mobile|contact\s+business)\s*:?\s*$/i;

    const normalizeContactText = (value) => String(value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();

    const getContactLineElement = (element) => {
      if (!element || !contactRoot.contains(element)) return null;

      const lineElement = element.closest('p, li, address, dd, dt');
      if (lineElement && contactRoot.contains(lineElement)) return lineElement;

      const compactBlock = element.closest('div');
      if (compactBlock && compactBlock !== contactRoot && contactRoot.contains(compactBlock) && normalizeContactText(compactBlock.textContent).length <= 160) {
        return compactBlock;
      }

      return element;
    };

    const removeOrCleanContactPhone = (element, textNode = null) => {
      const lineElement = getContactLineElement(element);
      const lineText = normalizeContactText(lineElement ? lineElement.textContent : element?.textContent);

      if (lineElement && phoneLinePattern.test(lineText)) {
        lineElement.remove();
        return;
      }

      if (textNode) {
        textNode.nodeValue = normalizeContactText(textNode.nodeValue.replace(phonePatternGlobal, ''));
      } else if (element) {
        element.textContent = normalizeContactText(element.textContent.replace(phonePatternGlobal, ''));
        if (element.matches && element.matches('a[href^="tel:"]')) {
          element.removeAttribute('href');
        }
      }

      if (lineElement && phoneLabelOnlyPattern.test(normalizeContactText(lineElement.textContent))) {
        lineElement.remove();
      }
    };

    contactRoot.querySelectorAll('a[href^="tel:"], a[href*="9042005884"], a[href*="904-200-5884"]').forEach((link) => {
      const href = link.getAttribute('href') || '';

      if (phonePattern.test(href) || phonePattern.test(link.textContent || '')) {
        removeOrCleanContactPhone(link);
      }
    });

    contactRoot.querySelectorAll('p, li, address, dd, dt').forEach((element) => {
      const text = normalizeContactText(element.textContent);

      if (phoneLinePattern.test(text) || phoneLabelOnlyPattern.test(text)) {
        element.remove();
      }
    });

    const textNodes = [];
    const walker = document.createTreeWalker(contactRoot, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      if (phonePattern.test(node.nodeValue || '')) {
        textNodes.push(node);
      }

      node = walker.nextNode();
    }

    textNodes.forEach((textNode) => {
      removeOrCleanContactPhone(textNode.parentElement, textNode);
    });
  };

  let birdieContactPhoneCleanupQueued = false;
  const queueBirdieContactPhoneCleanup = () => {
    if (birdieContactPhoneCleanupQueued) return;

    birdieContactPhoneCleanupQueued = true;
    window.requestAnimationFrame(() => {
      birdieContactPhoneCleanupQueued = false;
      removeBirdieContactPhoneNumber();
    });
  };

  removeBirdieContactPhoneNumber();

  const birdieContactPhoneObserverRoot = document.getElementById('MainContent') || document.querySelector('main');
  if (birdieContactPhoneObserverRoot) {
    const birdieContactPhoneObserver = new MutationObserver(queueBirdieContactPhoneCleanup);
    birdieContactPhoneObserver.observe(birdieContactPhoneObserverRoot, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }


});

document.addEventListener('DOMContentLoaded', () => {
  const stickyAtc = document.querySelector('[data-product-sticky-atc]');
  const productButton = document.querySelector('.product-form__button');

  if (!stickyAtc || !productButton) return;

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0.1 });

    observer.observe(productButton);
  } else {
    stickyAtc.classList.add('is-visible');
  }
});

const birdieEmailInSystemStorageKey = 'birdieCoffeeFinderEmailInSystem';
const birdieLegacyPopupDismissedStorageKey = 'birdieCoffeeFinderPopupDismissedAt';

const readBirdieEmailInSystemFlag = () => {
  try {
    return window.localStorage.getItem(birdieEmailInSystemStorageKey) === 'true';
  } catch (error) {
    return false;
  }
};

const markBirdieEmailInSystem = (source = 'unknown') => {
  try {
    window.localStorage.setItem(birdieEmailInSystemStorageKey, 'true');
    window.localStorage.removeItem(birdieLegacyPopupDismissedStorageKey);
  } catch (error) {
    // Email-aware experiences still work for the current page when storage is unavailable.
  }

  document.dispatchEvent(new CustomEvent('birdie:email-in-system', {
    detail: { source }
  }));
};

const birdieIsKlaviyoBrowserIdentified = (attemptsRemaining = 12, delayMs = 250) => new Promise((resolve) => {
  let attempts = Math.max(0, Number(attemptsRemaining) || 0);
  const retryDelay = Math.max(50, Number(delayMs) || 250);

  const check = () => {
    if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
      try {
        Promise.resolve(window.klaviyo.isIdentified())
          .then((identified) => resolve(Boolean(identified)))
          .catch(() => resolve(false));
      } catch (error) {
        resolve(false);
      }
      return;
    }

    if (attempts <= 0) {
      resolve(false);
      return;
    }

    attempts -= 1;
    window.setTimeout(check, retryDelay);
  };

  check();
});

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('[data-birdie-email-in-system-success]')) {
    markBirdieEmailInSystem('footer-newsletter');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('[data-coffee-finder-popup]');
  if (!popup) return;
  if (popup.dataset.coffeeFinderInitialized === 'true') return;
  popup.dataset.coffeeFinderInitialized = 'true';

  const introPanel = popup.querySelector('[data-coffee-finder-intro-panel]');
  const quizPanel = popup.querySelector('[data-coffee-finder-quiz-panel]');
  const form = popup.querySelector('[data-coffee-finder-form]');
  const emailInput = popup.querySelector('[data-coffee-finder-email]');
  const submitButton = popup.querySelector('[data-coffee-finder-submit]');
  const message = popup.querySelector('[data-coffee-finder-message]');
  const closeButtons = popup.querySelectorAll('[data-coffee-finder-close]');

  const sessionStateKey = 'birdieCoffeeFinderPopupSessionState';
  const sessionSelectionsKey = 'birdieCoffeeFinderPopupSelections';
  const delayMs = Math.max(0, Number(popup.getAttribute('data-delay-ms')) || 0);
  const designMode = popup.getAttribute('data-design-mode') === 'true';
  const customerEmailKnown = popup.getAttribute('data-customer-email-known') === 'true';

  if (customerEmailKnown) {
    markBirdieEmailInSystem('shopify-customer');
  }

  const sessionStore = {
    get(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    },
    set(key, value) {
      try {
        window.sessionStorage.setItem(key, value);
      } catch (error) {
        // Ignore storage errors so the popup remains usable.
      }
    },
    remove(key) {
      try {
        window.sessionStorage.removeItem(key);
      } catch (error) {
        // Ignore storage errors.
      }
    }
  };

  const getSessionState = () => sessionStore.get(sessionStateKey) || '';
  const setSessionState = (state) => {
    sessionStore.set(sessionStateKey, state || '');
  };

  const pauseHomeHeroVideos = (shouldPause) => {
    document.querySelectorAll('.hero-home__video').forEach((video) => {
      if (!video) return;

      if (shouldPause) {
        if (!video.paused) {
          video.dataset.birdieCoffeeFinderPaused = 'true';
          video.pause();
        }

        return;
      }

      if (video.dataset.birdieCoffeeFinderPaused !== 'true') return;
      delete video.dataset.birdieCoffeeFinderPaused;

      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    });
  };

  const shouldOpenPopup = () => {
    const sessionState = getSessionState();

    // Keep an in-progress quiz available for this visit, but do not reopen after
    // a shopper closes or completes it in the same browser session.
    if (sessionState === 'quiz') return true;
    if (sessionState === 'closed' || sessionState === 'completed') return false;
    if (designMode) return true;

    // A new browser visit gets the popup unless this browser has successfully
    // submitted an email before or Shopify already knows the logged-in customer.
    return !(customerEmailKnown || readBirdieEmailInSystemFlag());
  };

  const isKlaviyoBrowserIdentified = () => birdieIsKlaviyoBrowserIdentified(8, 250);

  const openPopupForVisit = () => {
    if (!shouldOpenPopup()) return;

    if (designMode) {
      openPopup();
      return;
    }

    isKlaviyoBrowserIdentified().then((identified) => {
      if (identified) {
        markBirdieEmailInSystem('klaviyo-identified');
        return;
      }

      if (shouldOpenPopup()) {
        openPopup();
      }
    });
  };

  const openPopup = () => {
    popup.hidden = false;
    document.body.classList.add('coffee-finder-popup-is-open');
    pauseHomeHeroVideos(true);

    window.requestAnimationFrame(() => {
      const focusTarget = quizPanel && !quizPanel.hidden
        ? popup.querySelector('[data-bundle-question].is-active [data-bundle-option]') || popup.querySelector('[data-bundle-option]') || popup.querySelector('.coffee-finder-popup__close')
        : emailInput || popup.querySelector('.coffee-finder-popup__close');

      if (focusTarget) {
        focusTarget.focus({ preventScroll: true });
      }
    });
  };

  const closePopup = () => {
    popup.hidden = true;
    document.body.classList.remove('coffee-finder-popup-is-open');
    pauseHomeHeroVideos(false);
    setSessionState('closed');
    sessionStore.remove(sessionSelectionsKey);
  };

  const showQuiz = () => {
    if (introPanel) introPanel.hidden = true;
    if (quizPanel) quizPanel.hidden = false;
    popup.hidden = false;
    document.body.classList.add('coffee-finder-popup-is-open');
    pauseHomeHeroVideos(true);
    popup.setAttribute('data-coffee-finder-state', 'quiz');
    setSessionState('quiz');

    window.requestAnimationFrame(() => {
      const quizHeading = popup.querySelector('#coffee-finder-popup-quiz-title');
      const firstOption = popup.querySelector('[data-bundle-question].is-active [data-bundle-option]');

      if (quizHeading) {
        quizHeading.setAttribute('tabindex', '-1');
        quizHeading.focus({ preventScroll: true });
      } else if (firstOption) {
        firstOption.focus({ preventScroll: true });
      }
    });
  };

  const keepPopupVisibleWhenActive = () => {
    const sessionState = getSessionState();
    const shouldStayOpen = sessionState === 'quiz' || sessionState === 'completed';

    if (!shouldStayOpen) return;

    if (popup.hidden) {
      popup.hidden = false;
    }

    document.body.classList.add('coffee-finder-popup-is-open');
    pauseHomeHeroVideos(true);
  };

  if (window.MutationObserver) {
    const popupVisibilityObserver = new MutationObserver(keepPopupVisibleWhenActive);
    popupVisibilityObserver.observe(popup, {
      attributes: true,
      attributeFilter: ['hidden']
    });
  }

  closeButtons.forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden && popup.getAttribute('data-coffee-finder-state') !== 'quiz') {
      closePopup();
    }
  });

  const klaviyoConfig = {
    enabled: popup.getAttribute('data-klaviyo-enabled') === 'true',
    publicKey: (popup.getAttribute('data-klaviyo-public-key') || '').trim(),
    listId: (popup.getAttribute('data-klaviyo-list-id') || '').trim(),
    source: (popup.getAttribute('data-klaviyo-source') || 'Birdie Coffee Finder Popup').trim(),
    revision: (popup.getAttribute('data-klaviyo-revision') || '2026-04-15').trim(),
    trackQuizResults: popup.getAttribute('data-klaviyo-track-quiz-results') === 'true',
    eventName: (popup.getAttribute('data-klaviyo-event-name') || 'Completed Coffee Finder Quiz').trim()
  };

  let submittedEmail = '';
  let quizEventSent = false;

  const isKlaviyoReady = () => Boolean(
    klaviyoConfig.enabled &&
    klaviyoConfig.publicKey &&
    klaviyoConfig.listId &&
    window.fetch
  );

  const postJsonToKlaviyo = (path, payload) => {
    if (!isKlaviyoReady()) {
      return Promise.resolve({ skipped: true });
    }

    const endpoint = `https://a.klaviyo.com${path}?company_id=${encodeURIComponent(klaviyoConfig.publicKey)}`;

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: klaviyoConfig.revision
      },
      body: JSON.stringify(payload)
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`Klaviyo request failed with status ${response.status}`);
      }

      return response;
    });
  };

  const subscribeEmailToKlaviyo = (email) => {
    if (!email || !isKlaviyoReady()) {
      return Promise.resolve({ skipped: true });
    }

    return postJsonToKlaviyo('/client/subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: klaviyoConfig.source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                properties: {
                  coffee_finder_popup: true,
                  coffee_finder_source: klaviyoConfig.source,
                  signup_location: 'Coffee Finder Popup'
                },
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: klaviyoConfig.listId
            }
          }
        }
      }
    });
  };

  const getSelectionPropertyMap = (selections = {}) => {
    const properties = {};

    Object.entries(selections).forEach(([key, selection]) => {
      const propertyKey = key.replace(/-/g, '_');
      properties[`coffee_finder_${propertyKey}`] = selection && selection.value ? selection.value : '';
      properties[`coffee_finder_${propertyKey}_label`] = selection && selection.label ? selection.label : '';
    });

    return properties;
  };

  const trackKlaviyoQuizCompletion = (detail) => {
    if (!submittedEmail || !klaviyoConfig.trackQuizResults || quizEventSent || !isKlaviyoReady()) {
      return;
    }

    if (!detail || !detail.complete) {
      return;
    }

    quizEventSent = true;

    postJsonToKlaviyo('/client/events', {
      data: {
        type: 'event',
        attributes: {
          properties: Object.assign({
            source: klaviyoConfig.source,
            quiz_location: 'Coffee Finder Popup',
            recommended_coffees: Array.isArray(detail.recommendedLabels) ? detail.recommendedLabels : [],
            recommended_product_urls: Array.isArray(detail.recommendedProducts) ? detail.recommendedProducts.map((product) => product.url).filter(Boolean) : []
          }, getSelectionPropertyMap(detail.selections || {})),
          metric: {
            data: {
              type: 'metric',
              attributes: {
                name: klaviyoConfig.eventName
              }
            }
          },
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: submittedEmail
              }
            }
          }
        }
      }
    }).catch((error) => {
      console.warn('Birdie coffee finder Klaviyo quiz event failed.', error);
    });
  };

  popup.addEventListener('birdie:bundle-recommendations-update', (event) => {
    const detail = event.detail || {};

    if (detail.sectionId !== 'coffee-finder-popup') {
      return;
    }

    const selectionsForStorage = {};
    Object.entries(detail.selections || {}).forEach(([key, selection]) => {
      selectionsForStorage[key] = selection && selection.value ? selection.value : '';
    });

    sessionStore.set(sessionSelectionsKey, JSON.stringify(selectionsForStorage));
    trackKlaviyoQuizCompletion(detail);

    if (detail.complete) {
      setSessionState('completed');
      popup.hidden = false;
      document.body.classList.add('coffee-finder-popup-is-open');
      pauseHomeHeroVideos(true);
      return;
    }

    if (popup.getAttribute('data-coffee-finder-state') === 'quiz' || Object.values(selectionsForStorage).some(Boolean)) {
      setSessionState('quiz');
      popup.hidden = false;
      document.body.classList.add('coffee-finder-popup-is-open');
      pauseHomeHeroVideos(true);
    }
  });

  if (form) {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        form.reportValidity();
        return;
      }

      submittedEmail = emailInput ? String(emailInput.value || '').trim() : '';
      quizEventSent = false;
      setSessionState('quiz');

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      if (message) {
        message.textContent = 'Thanks — opening the coffee quiz now.';
      }

      const formData = new FormData(form);
      const rawAction = form.getAttribute('action') || '/contact';
      const action = rawAction.split('#')[0] || '/contact';

      const finish = () => {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
        }
      };

      // Open the quiz immediately so shoppers can keep moving. Shopify/Klaviyo
      // signup requests continue in the background and should never block the quiz.
      showQuiz();

      if (!window.fetch) {
        finish();
        return;
      }

      const shopifyRequest = fetch(action, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html'
        }
      }).then((response) => ({
        source: 'shopify',
        emailStored: response.ok
      })).catch(() => ({
        source: 'shopify',
        emailStored: false
      }));

      const klaviyoRequest = subscribeEmailToKlaviyo(submittedEmail).then((response) => ({
        source: 'klaviyo',
        emailStored: Boolean(response && !response.skipped)
      })).catch((error) => {
        console.warn('Birdie coffee finder Klaviyo signup failed.', error);
        return {
          source: 'klaviyo',
          emailStored: false
        };
      });

      Promise.all([shopifyRequest, klaviyoRequest])
        .then((results) => {
          if (results.some((result) => result && result.emailStored)) {
            markBirdieEmailInSystem('coffee-finder-popup');
          }
        })
        .finally(finish);
    });
  }

  if (shouldOpenPopup()) {
    if (getSessionState() === 'quiz') {
      showQuiz();
      openPopup();
    } else {
      window.setTimeout(openPopupForVisit, delayMs);
    }
  }
});


// Birdie first-order discount widget: eligibility, email capture, code copy, and apply flow.
document.addEventListener('DOMContentLoaded', () => {
  const widget = document.querySelector('[data-birdie-discount-widget]');
  if (!widget || widget.dataset.birdieDiscountInitialized === 'true') return;
  widget.dataset.birdieDiscountInitialized = 'true';

  const trigger = widget.querySelector('[data-birdie-discount-trigger]');
  const panel = widget.querySelector('[data-birdie-discount-panel]');
  const closeButton = widget.querySelector('[data-birdie-discount-close]');
  const lockedPanel = widget.querySelector('[data-birdie-discount-locked]');
  const unlockedPanel = widget.querySelector('[data-birdie-discount-unlocked]');
  const form = document.getElementById('birdie-first-order-discount-form');
  const emailInput = widget.querySelector('[data-birdie-discount-email]');
  const submitButton = widget.querySelector('[data-birdie-discount-submit]');
  const formStatus = widget.querySelector('[data-birdie-discount-status]');
  const unlockedStatus = widget.querySelector('[data-birdie-discount-unlocked-status]');
  const copyButton = widget.querySelector('[data-birdie-discount-copy]');
  const copyLabel = widget.querySelector('[data-birdie-discount-copy-label]');
  const applyButton = widget.querySelector('[data-birdie-discount-apply]');
  const serverSuccess = widget.querySelector('[data-birdie-discount-server-success]');
  const customerEmailKnown = widget.getAttribute('data-customer-email-known') === 'true';
  const discountCode = (widget.getAttribute('data-discount-code') || '').trim();
  const discountPercent = (widget.getAttribute('data-discount-percent') || '10').trim();
  const discountRedirect = (widget.getAttribute('data-discount-redirect') || '/collections/coffee').trim();
  let isUnlocked = false;
  let lastFocusedElement = null;

  const klaviyoConfig = {
    enabled: widget.getAttribute('data-klaviyo-enabled') === 'true',
    publicKey: (widget.getAttribute('data-klaviyo-public-key') || '').trim(),
    listId: (widget.getAttribute('data-klaviyo-list-id') || '').trim(),
    source: (widget.getAttribute('data-klaviyo-source') || 'Birdie First Order Discount Widget').trim(),
    revision: (widget.getAttribute('data-klaviyo-revision') || '2026-04-15').trim()
  };

  const setCoffeeFinderClosedForVisit = () => {
    try {
      window.sessionStorage.setItem('birdieCoffeeFinderPopupSessionState', 'closed');
    } catch (error) {
      // The discount widget remains usable if session storage is unavailable.
    }
  };

  const focusPanel = () => {
    const focusTarget = isUnlocked
      ? copyButton || widget.querySelector('[data-birdie-discount-apply]') || closeButton
      : emailInput || widget.querySelector('.birdie-discount-widget__sign-in') || closeButton;

    if (focusTarget) {
      focusTarget.focus({ preventScroll: true });
    }
  };

  const setPanelOpen = (shouldOpen, options = {}) => {
    if (!panel || !trigger) return;

    const open = Boolean(shouldOpen);
    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    widget.classList.toggle('is-open', open);

    if (open) {
      lastFocusedElement = document.activeElement;
      setCoffeeFinderClosedForVisit();
      window.requestAnimationFrame(focusPanel);
      return;
    }

    if (options.restoreFocus !== false && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus({ preventScroll: true });
    }
  };

  const setUnlocked = (unlocked) => {
    isUnlocked = Boolean(unlocked);
    widget.classList.toggle('is-unlocked', isUnlocked);
    widget.setAttribute('data-discount-eligibility', isUnlocked ? 'unlocked' : 'locked');

    if (lockedPanel) lockedPanel.hidden = isUnlocked;
    if (unlockedPanel) unlockedPanel.hidden = !isUnlocked;

    if (trigger) {
      trigger.setAttribute(
        'aria-label',
        isUnlocked
          ? `Open your unlocked ${discountPercent} percent off offer`
          : `Open the ${discountPercent} percent off first-order offer`
      );
    }
  };

  const unlockOffer = (source) => {
    setUnlocked(true);
    markBirdieEmailInSystem(source || 'first-order-discount-widget');
  };

  const isKlaviyoSubscriptionReady = () => Boolean(
    klaviyoConfig.enabled &&
    klaviyoConfig.publicKey &&
    klaviyoConfig.listId &&
    window.fetch
  );

  const subscribeEmailToKlaviyo = (email) => {
    if (!email || !isKlaviyoSubscriptionReady()) {
      return Promise.resolve({ skipped: true });
    }

    const endpoint = `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(klaviyoConfig.publicKey)}`;

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: klaviyoConfig.revision
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: klaviyoConfig.source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  properties: {
                    first_order_discount_widget: true,
                    signup_location: 'First Order Discount Widget'
                  },
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: klaviyoConfig.listId
              }
            }
          }
        }
      })
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`Klaviyo request failed with status ${response.status}`);
      }

      return response;
    });
  };

  document.addEventListener('birdie:email-in-system', () => {
    setUnlocked(true);
  });

  if (trigger && panel) {
    trigger.addEventListener('click', () => {
      setPanelOpen(panel.hidden);
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', () => setPanelOpen(false));
  }

  document.addEventListener('pointerdown', (event) => {
    if (!panel || panel.hidden || widget.contains(event.target)) return;
    setPanelOpen(false, { restoreFocus: false });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && panel && !panel.hidden) {
      setPanelOpen(false);
    }
  });

  if (form) {
    form.addEventListener('submit', (event) => {
      if (!window.fetch) return;

      event.preventDefault();

      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const email = emailInput ? String(emailInput.value || '').trim() : '';
      if (!email) return;

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      if (formStatus) {
        formStatus.textContent = 'Saving your email and unlocking the offer...';
      }

      const formData = new FormData(form);
      const rawAction = form.getAttribute('action') || '/contact';
      const action = rawAction.split('#')[0] || '/contact';

      const shopifyRequest = fetch(action, {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html'
        }
      }).then(async (response) => {
        const html = await response.text();
        let emailStored = response.ok;

        try {
          const responseDocument = new DOMParser().parseFromString(html, 'text/html');
          const successMarker = responseDocument.querySelector('[data-birdie-discount-server-success]');
          const errorTarget = responseDocument.querySelector('#birdie-first-order-discount-form .form-status--error');
          const errorText = errorTarget ? String(errorTarget.textContent || '').toLowerCase() : '';
          const alreadyKnown = Boolean(
            errorText &&
            /(already|taken|exists|subscribed)/.test(errorText) &&
            /(email|customer|subscribe|account)/.test(errorText)
          );

          if (successMarker || alreadyKnown) {
            emailStored = true;
          } else if (errorTarget) {
            emailStored = false;
          }
        } catch (error) {
          // Use the HTTP result when the response cannot be parsed.
        }

        return {
          source: 'shopify',
          emailStored
        };
      }).catch(() => ({
        source: 'shopify',
        emailStored: false
      }));

      const klaviyoRequest = subscribeEmailToKlaviyo(email).then((response) => ({
        source: 'klaviyo',
        emailStored: Boolean(response && !response.skipped)
      })).catch((error) => {
        console.warn('Birdie first-order widget Klaviyo signup failed.', error);
        return {
          source: 'klaviyo',
          emailStored: false
        };
      });

      Promise.all([shopifyRequest, klaviyoRequest])
        .then((results) => {
          const storedResult = results.find((result) => result && result.emailStored);

          if (!storedResult) {
            throw new Error('Email could not be saved.');
          }

          unlockOffer(`discount-widget-${storedResult.source}`);

          if (unlockedStatus) {
            unlockedStatus.textContent = `Your ${discountPercent}% off code is unlocked.`;
          }

          window.requestAnimationFrame(focusPanel);
        })
        .catch(() => {
          if (formStatus) {
            formStatus.textContent = 'We could not save your email. Please try again or sign in.';
          }
        })
        .finally(() => {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }
        });
    });
  }

  if (copyButton) {
    copyButton.addEventListener('click', () => {
      if (!discountCode) return;

      const setCopiedState = () => {
        if (copyLabel) copyLabel.textContent = 'Copied';
        if (unlockedStatus) unlockedStatus.textContent = `${discountCode} copied to your clipboard.`;

        window.setTimeout(() => {
          if (copyLabel) copyLabel.textContent = 'Copy';
        }, 1800);
      };

      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(discountCode)
          .then(setCopiedState)
          .catch(() => {
            if (unlockedStatus) unlockedStatus.textContent = `Use code ${discountCode} at checkout.`;
          });
        return;
      }

      const helper = document.createElement('textarea');
      helper.value = discountCode;
      helper.setAttribute('readonly', '');
      helper.style.position = 'fixed';
      helper.style.opacity = '0';
      document.body.appendChild(helper);
      helper.select();

      try {
        document.execCommand('copy');
        setCopiedState();
      } catch (error) {
        if (unlockedStatus) unlockedStatus.textContent = `Use code ${discountCode} at checkout.`;
      }

      helper.remove();
    });
  }

  if (applyButton) {
    applyButton.addEventListener('click', (event) => {
      if (!discountCode || !window.fetch) return;

      event.preventDefault();
      if (applyButton.getAttribute('aria-busy') === 'true') return;

      const fallbackUrl = applyButton.getAttribute('href');
      const cartRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      const cartUpdateUrl = `${cartRoot}cart/update.js`;
      const shopRedirect = (discountRedirect || `${cartRoot}collections/coffee`)
        .replace(/^shopify:\/\//i, '/');

      applyButton.setAttribute('aria-busy', 'true');
      applyButton.setAttribute('aria-disabled', 'true');
      applyButton.dataset.originalLabel = applyButton.textContent || '';
      applyButton.textContent = `Applying ${discountPercent}% off...`;

      if (unlockedStatus) {
        unlockedStatus.textContent = `Applying ${discountCode} to your cart...`;
      }

      fetch(cartUpdateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ discount: discountCode })
      })
        .then(async (response) => {
          if (!response.ok) {
            throw new Error(`Cart update failed with status ${response.status}`);
          }

          await response.json();

          if (unlockedStatus) {
            unlockedStatus.textContent = `${discountCode} is ready. Opening the shop...`;
          }

          window.location.assign(shopRedirect);
        })
        .catch((error) => {
          console.warn('Birdie discount could not be applied through the cart API.', error);

          if (unlockedStatus) {
            unlockedStatus.textContent = `Opening the shop with code ${discountCode}...`;
          }

          if (fallbackUrl) {
            window.location.assign(fallbackUrl);
            return;
          }

          applyButton.removeAttribute('aria-busy');
          applyButton.removeAttribute('aria-disabled');
          applyButton.textContent = applyButton.dataset.originalLabel || `Apply ${discountPercent}% off & shop`;
        });
    });
  }

  if (customerEmailKnown) {
    unlockOffer('shopify-customer');
  } else if (serverSuccess) {
    unlockOffer('discount-widget-server-success');
  } else if (readBirdieEmailInSystemFlag()) {
    setUnlocked(true);
  } else {
    setUnlocked(false);
    birdieIsKlaviyoBrowserIdentified(12, 250).then((identified) => {
      if (identified) {
        unlockOffer('klaviyo-identified');
      }
    });
  }
});

// Birdie premium commerce enhancements: AJAX quick add, cart count updates, and variant-aware product pages.
document.addEventListener('DOMContentLoaded', () => {
  const parseJsonScript = (script) => {
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || 'null');
    } catch (error) {
      return null;
    }
  };

  const escapeHtmlLocal = (value) => String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const priceMarkup = (variant) => {
    if (!variant) return '';

    if (variant.compareAtPrice) {
      return [
        '<span class="price">',
        '<span class="compare-at">', escapeHtmlLocal(variant.compareAtPrice), '</span>',
        '<span>', escapeHtmlLocal(variant.price), '</span>',
        '</span>'
      ].join('');
    }

    return ['<span class="price"><span>', escapeHtmlLocal(variant.price), '</span></span>'].join('');
  };

  const setButtonState = (button, variant, availableLabel = 'Add to cart') => {
    if (!button || !variant) return;
    button.disabled = !variant.available;
    button.textContent = variant.available ? availableLabel : 'Sold out';
  };

  document.querySelectorAll('.product-section').forEach((section) => {
    const variants = parseJsonScript(section.querySelector('[data-product-variant-state]')) || [];
    const variantSelect = section.querySelector('[data-product-variant-select]');

    if (!variants.length || !variantSelect) return;

    const priceTargets = [
      section.querySelector('[data-product-price]'),
      document.querySelector('[data-product-sticky-price]')
    ].filter(Boolean);
    const addButtons = [
      section.querySelector('[data-product-add-button]'),
      document.querySelector('[data-product-sticky-button]')
    ].filter(Boolean);
    const mainImage = section.querySelector('[data-main-product-image]');
    const defaultAddLabel = addButtons[0] ? (addButtons[0].textContent || 'Add to cart').trim() : 'Add to cart';

    const syncVariant = () => {
      const selectedVariant = variants.find((variant) => String(variant.id) === String(variantSelect.value));
      if (!selectedVariant) return;

      priceTargets.forEach((target) => {
        target.innerHTML = priceMarkup(selectedVariant);
      });

      addButtons.forEach((button) => setButtonState(button, selectedVariant, defaultAddLabel));

      if (mainImage && selectedVariant.imageUrl) {
        mainImage.setAttribute('src', selectedVariant.imageUrl);
        mainImage.setAttribute('alt', selectedVariant.imageAlt || '');
      }
    };

    variantSelect.addEventListener('change', syncVariant);
    syncVariant();
  });

  const updateCartCount = (itemCount) => {
    document.querySelectorAll('[data-cart-count]').forEach((counter) => {
      counter.textContent = String(itemCount || 0);
      counter.classList.toggle('is-empty', !itemCount);
    });

    document.querySelectorAll('[data-header-cart-link]').forEach((link) => {
      link.setAttribute('aria-label', `Cart, ${itemCount || 0} item${itemCount === 1 ? '' : 's'}`);
    });
  };

  const fetchCart = () => fetch('/cart.js', {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin'
  }).then((response) => response.ok ? response.json() : null);

  document.querySelectorAll('[data-quick-add-form]').forEach((form) => {
    const button = form.querySelector('[data-quick-add-button]');
    const status = form.querySelector('[data-quick-add-status]');
    const defaultLabel = button ? button.textContent : 'Quick add';
    const productTitle = form.getAttribute('data-product-title') || 'This item';

    form.addEventListener('submit', (event) => {
      if (!window.fetch || !window.FormData) return;

      event.preventDefault();

      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding...';
      }

      if (status) {
        status.textContent = `Adding ${productTitle} to your cart.`;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((error) => Promise.reject(error));
          }

          return response.json();
        })
        .then(() => fetchCart())
        .then((cart) => {
          if (cart && typeof cart.item_count !== 'undefined') {
            updateCartCount(cart.item_count);
          }

          if (button) {
            button.textContent = 'Added';
          }

          if (status) {
            status.textContent = `${productTitle} was added to your cart.`;
          }

          document.dispatchEvent(new CustomEvent('birdie:cart-updated', { detail: cart || {} }));
        })
        .catch((error) => {
          const errorMessage = error && (error.description || error.message)
            ? (error.description || error.message)
            : 'We could not add this item. Please try again.';

          if (button) {
            button.textContent = 'Try again';
          }

          if (status) {
            status.textContent = errorMessage;
            status.classList.remove('visually-hidden');
          }
        })
        .finally(() => {
          window.setTimeout(() => {
            if (button) {
              button.disabled = false;
              button.removeAttribute('aria-busy');
              button.textContent = defaultLabel;
            }

            if (status && !status.classList.contains('visually-hidden')) {
              status.classList.add('visually-hidden');
            }
          }, 1800);
        });
    });
  });
});


// Product pages: suppress the Selleasy Bundle + Save upsell widget.
// This is a scoped fallback in case the app re-enables or injects its embed after page load.
document.addEventListener('DOMContentLoaded', () => {
  const isProductPage = document.body.classList.contains('template-product') || /^\/products\//.test(window.location.pathname);
  // The Selleasy app embed is disabled in this theme configuration. Avoid attaching
  // a page-wide MutationObserver on every product page for an inactive app.
  if (!isProductPage || window.__birdieSelleasyProductGuard || !document.documentElement.hasAttribute('data-birdie-selleasy-enabled')) return;

  window.__birdieSelleasyProductGuard = true;

  const selleasySelectors = [
    '[id*="selleasy" i]',
    '[class*="selleasy" i]',
    '[data-selleasy]',
    '[data-selleasy-widget]',
    '[id*="lb-upsell" i]',
    '[class*="lb-upsell" i]',
    '[id*="lb-fbt" i]',
    '[class*="lb-fbt" i]',
    '[id*="lb-bundle" i]',
    '[class*="lb-bundle" i]',
    '[data-app-name="selleasy" i]',
    '[data-app="selleasy" i]',
    'iframe[src*="selleasy" i]',
    'iframe[src*="upsell-app.logbase.io" i]'
  ].join(',');

  const hideElement = (element) => {
    if (!(element instanceof HTMLElement)) return;
    element.hidden = true;
    element.setAttribute('aria-hidden', 'true');
    element.style.setProperty('display', 'none', 'important');
  };

  const hideKnownWidgets = (root = document) => {
    if (root instanceof Element && root.matches(selleasySelectors)) {
      hideElement(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(selleasySelectors).forEach(hideElement);
    }
  };

  const hideMatchingBundleCopy = (root = document) => {
    const candidates = [];

    if (root instanceof Element && root.matches('section, aside, form, div')) {
      candidates.push(root);
    }

    if (root.querySelectorAll) {
      candidates.push(...root.querySelectorAll('section, aside, form, div'));
    }

    const matches = candidates.filter((element) => {
      if (!(element instanceof HTMLElement) || element.hidden) return false;
      const copy = (element.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!copy || copy.length > 20000) return false;

      const hasBundleHeading = copy.includes('bundle + save') || copy.includes('bundle and save');
      const hasOfferCopy = copy.includes('get 10% when you add more') || copy.includes('when you add more');
      const hasWidgetControls = copy.includes('delivery frequency') || copy.includes('variant');
      return hasBundleHeading && hasOfferCopy && hasWidgetControls;
    });

    if (!matches.length) return;

    // The smallest matching container is the injected offer itself rather than the product page shell.
    matches.sort((first, second) => (first.textContent || '').length - (second.textContent || '').length);
    hideElement(matches[0]);
  };

  let queued = false;
  const cleanProductPage = (root = document) => {
    hideKnownWidgets(root);
    hideMatchingBundleCopy(root);
  };

  const queueCleanup = (root = document) => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      cleanProductPage(root);
    });
  };

  cleanProductPage(document);

  if (window.MutationObserver) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) queueCleanup(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', () => queueCleanup(document));
  document.addEventListener('change', () => window.setTimeout(() => queueCleanup(document), 50), true);
});
